import React            from 'react';

class Wrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return(
            <div className={ `marketkit-textfield-wrapper${ p.isFocused ? ' focused' : '' }${ p.className ? ' ' + p.className : '' }` }>
                { this.props.children }
            </div>
        )
    }
}

export default Wrapper;